import { render } from "./ImportMember.vue?vue&type=template&id=55f7032c&scoped=true"
import script from "./ImportMember.vue?vue&type=script&lang=js"
export * from "./ImportMember.vue?vue&type=script&lang=js"

import "./ImportMember.vue?vue&type=style&index=0&id=55f7032c&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f7032c"]])

export default __exports__